<ng-container *ngIf="!editing(); else editForm">
  <app-button
    type="button"
    backgroundColor="var(--blue-500)"
    text="Cadastrar NCM"
    icon="pi-plus"
    textAlign="flex-start"
    [fullWidth]="false"
    (click)="newNcm()"
  ></app-button>
  <ng-container *ngIf="ncms().length; else empty">
    <div class="ncms">
      <app-ncm-card
        (edit)="startEditing(ncm)"
        (remove)="deleteNcm(ncm)"
        [ncm]="ncm"
        *ngFor="let ncm of ncms() | sort: 'updatedAt' : 'DESC'"
      >
      </app-ncm-card>
    </div>
    <div class="pagination">
      <p-paginator
        (onPageChange)="onPageChange($event)"
        [first]="0"
        [rows]="6"
        [totalRecords]="ncms().length"
      ></p-paginator>
    </div>
  </ng-container>
</ng-container>

<ng-template #empty>
  <div class="empty">
    <p>Você ainda não cadastrou nenhum NCM</p>
  </div>
</ng-template>

<ng-template #editForm>
  <div class="buttons">
    <app-button
      backgroundColor="var(--slate-500)"
      text="Voltar"
      (click)="close()"
      textAlign="flex-start"
      icon="pi-arrow-left"
      [fullWidth]="false"
    ></app-button>
    <app-button
      backgroundColor="var(--orange-500)"
      text="Descartar alterações"
      icon="pi-trash"
      textAlign="flex-start"
      [fullWidth]="false"
      (click)="discardChanges()"
    ></app-button>
  </div>
  <form [formGroup]="form()" (ngSubmit)="submit()">
    <app-section title="Seleção de NCM">
      <app-fields>
        <app-select
          label="NCM"
          [options]="ncmList"
          [virtualScroll]="true"
          [filter]="true"
          formControlName="ncm"
        ></app-select>
        <app-input mask="00.000.00" label="CEST" formControlName="cest">
          <small>
            <a
              href="https://codigocest.com.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Consulte aqui
              <span class="pi pi-external-link"></span>
            </a>
          </small>
        </app-input>
      </app-fields>
    </app-section>
    <ng-container formGroupName="tributos">
      <app-section
        formGroupName="icms"
        title="ICMS"
        [description]="
          company()?.regimeTributario === '3' ||
          company()?.regimeTributario === '4'
            ? 'Os tributos do ICMS detalhados abaixo serão aplicados APENAS ao NCM selecionado. Para LP/LR, o valor da Base de Cálculo (BC) é por produto e será incluído na NF-e.'
            : 'Os tributos do ICMS detalhados abaixo serão aplicados APENAS ao NCM selecionado.'
        "
      >
        <app-fields>
          <app-select
            label="Origem"
            formControlName="origem"
            [options]="originList"
          ></app-select>
          <app-select
            label="CST"
            formControlName="cst"
            [options]="company()?.simplesNacional ? icmsCstList2 : icmsCstList1"
          ></app-select>
          <ng-container [ngSwitch]="icms?.get('cst')?.value">
            <ng-container *ngSwitchCase="'00'">
              <ng-container *ngTemplateOutlet="aliquota"></ng-container>
              <ng-container *ngTemplateOutlet="bcForm1"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'10'">
              <ng-container *ngTemplateOutlet="aliquota"></ng-container>
              <ng-container *ngTemplateOutlet="bcForm1"></ng-container>
              <ng-container *ngTemplateOutlet="stForm1"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'20'">
              <ng-container *ngTemplateOutlet="aliquota"></ng-container>
              <ng-container *ngTemplateOutlet="bcForm2"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'30'">
              <ng-container *ngTemplateOutlet="stForm1"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'90'">
              <ng-container *ngTemplateOutlet="aliquota"></ng-container>
              <ng-container *ngTemplateOutlet="bcForm2"></ng-container>
              <ng-container *ngTemplateOutlet="stForm1"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'101'">
              <ng-container *ngTemplateOutlet="creditoSimples"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'201'">
              <ng-container *ngTemplateOutlet="stForm1"></ng-container>
              <ng-container *ngTemplateOutlet="creditoSimples"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'202'">
              <ng-container *ngTemplateOutlet="stForm1"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'203'">
              <ng-container *ngTemplateOutlet="stForm1"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'500'">
              <ng-container *ngTemplateOutlet="stForm2"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'900'">
              <ng-container *ngTemplateOutlet="aliquota"></ng-container>
              <ng-container *ngTemplateOutlet="bcForm2"></ng-container>
              <ng-container *ngTemplateOutlet="stForm1"></ng-container>
              <ng-container *ngTemplateOutlet="creditoSimples"></ng-container>
            </ng-container>
            <ng-template #aliquota>
              <app-input
                label="Aliquota"
                mask="percent.2"
                formControlName="aliquota"
              ></app-input>
            </ng-template>
            <ng-template #creditoSimples>
              <ng-container formGroupName="creditoSimplesNacional">
                <app-input
                  label="Percentual do crédito"
                  mask="percent.2"
                  formControlName="percentual"
                ></app-input>
                <app-input
                  label="Valor do crédito"
                  mask="separator.2"
                  formControlName="valor"
                >
                </app-input>
              </ng-container>
            </ng-template>
            <ng-template #bcForm1>
              <ng-container formGroupName="baseCalculo">
                <app-select
                  [options]="mdList"
                  formControlName="modalidadeDeterminacao"
                  label="Mod. de determinação da BC"
                ></app-select>
                <app-input
                  label="Valor da BC"
                  mask="separator.2"
                  formControlName="valor"
                  [title]="
                    company()?.regimeTributario === '3' ||
                    company()?.regimeTributario === '4'
                      ? 'Este valor é por produto e será incluído na NF-e para LP/LR'
                      : ''
                  "
                >
                </app-input>
              </ng-container>
            </ng-template>
            <ng-template #bcForm2>
              <ng-container formGroupName="baseCalculo">
                <app-select
                  [options]="mdList"
                  formControlName="modalidadeDeterminacao"
                  label="Mod. de determinação da BC"
                ></app-select>
                <app-input
                  label="Valor da BC"
                  mask="separator.2"
                  formControlName="valor"
                  [title]="
                    company()?.regimeTributario === '3' ||
                    company()?.regimeTributario === '4'
                      ? 'Este valor é por produto e será incluído na NF-e para LP/LR'
                      : ''
                  "
                >
                </app-input>
                <app-input
                  label="Percentual de redução da BC"
                  mask="percent.2"
                  formControlName="percentualReducao"
                >
                </app-input>
              </ng-container>
            </ng-template>
            <ng-template #stForm1>
              <ng-container formGroupName="substituicaoTributaria">
                <app-input
                  label="Aliquota"
                  mask="percent.2"
                  formControlName="aliquota"
                ></app-input>
                <ng-container formGroupName="baseCalculo">
                  <app-select
                    [options]="mdstList"
                    label="Mod. de determinação da BC ST"
                    formControlName="modalidadeDeterminacao"
                  ></app-select>
                  <app-input
                    mask="separator.2"
                    label="Valor da BC ST"
                    formControlName="valor"
                  >
                  </app-input>
                  <app-input
                    label="Percentual de redução da BC ST"
                    formControlName="percentualReducao"
                    mask="percent.2"
                  >
                  </app-input>
                </ng-container>
              </ng-container>
            </ng-template>
            <ng-template #stForm2>
              <ng-container formGroupName="substituicaoTributaria">
                <app-input
                  label="Aliquota"
                  mask="percent.2"
                  formControlName="aliquota"
                ></app-input>
                <ng-container formGroupName="baseCalculo">
                  <app-input
                    mask="separator.2"
                    label="Valor da BC ST"
                    formControlName="valor"
                  >
                  </app-input>
                </ng-container>
              </ng-container>
            </ng-template>
          </ng-container>
        </app-fields>
      </app-section>
      <app-section
        title="PIS"
        [description]="
          company()?.regimeTributario === '3' ||
          company()?.regimeTributario === '4'
            ? 'Para empresas com Lucro Presumido ou Lucro Real, os tributos de PIS serão calculados automaticamente pelo sistema na emissão da NF-e (PIS: 0.65% LP / 1.65% LR, CST 01). Os valores abaixo servem apenas como referência.'
            : 'Os tributos do PIS detalhados abaixo serão aplicados APENAS ao NCM selecionado.'
        "
        formGroupName="pis"
      >
        <app-fields>
          <app-select
            label="CST"
            [options]="pisCofinsCstList"
            formControlName="cst"
          ></app-select>
          <app-input
            label="Alíquota (%)"
            formControlName="aliquota"
            mask="percent.2"
          ></app-input>
          <ng-container formGroupName="baseCalculo">
            <app-input
              label="Base de cálculo (%)"
              formControlName="valor"
              mask="percent.2"
            ></app-input>
          </ng-container>
        </app-fields>
      </app-section>
      <app-section
        title="COFINS"
        [description]="
          company()?.regimeTributario === '3' ||
          company()?.regimeTributario === '4'
            ? 'Para empresas com Lucro Presumido ou Lucro Real, os tributos de COFINS serão calculados automaticamente pelo sistema na emissão da NF-e (COFINS: 3.0% LP / 7.6% LR, CST 01). Os valores abaixo servem apenas como referência.'
            : 'Os tributos do COFINS detalhados abaixo serão aplicados APENAS ao NCM selecionado.'
        "
        formGroupName="cofins"
      >
        <app-fields>
          <app-select
            label="CST"
            [options]="pisCofinsCstList"
            formControlName="cst"
          ></app-select>
          <app-input
            label="Alíquota (%)"
            formControlName="aliquota"
            mask="percent.2"
          ></app-input>
          <ng-container formGroupName="baseCalculo">
            <app-input
              label="Base de cálculo (%)"
              formControlName="valor"
              mask="percent.2"
            ></app-input>
          </ng-container>
        </app-fields>
      </app-section>
      <app-section
        title="IBS/CBS (Reforma Tributária)"
        [description]="
          company()?.regimeTributario === '3' ||
          company()?.regimeTributario === '4'
            ? 'Obrigatório na NF-e desde 01/01/2026 para Lucro Presumido e Lucro Real. Informe o CST (3 dígitos) e a classificação tributária cClassTrib (6 dígitos) do IBS/CBS; alíquotas e valores são calculados automaticamente pela SEFAZ na emissão.'
            : 'Para Simples Nacional e MEI o grupo IBS/CBS só é obrigatório a partir de 04/01/2027. Deixe em branco para não enviar. Se preencher, informe CST (3 dígitos) e cClassTrib (6 dígitos); alíquotas e valores são calculados automaticamente pela SEFAZ na emissão.'
        "
        formGroupName="ibscbs"
      >
        <app-fields>
          <app-input
            label="Situação tributária IBS/CBS (CST)"
            formControlName="cst"
            mask="000"
          ></app-input>
          <app-input
            label="Classificação tributária IBS/CBS (cClassTrib)"
            formControlName="classificacao"
            mask="000000"
          ></app-input>
        </app-fields>
      </app-section>
    </ng-container>
    <div class="submit">
      <app-button
        text="Salvar"
        type="submit"
        icon="pi-save"
        [disabled]="!form().valid"
        backgroundColor="var(--teal-500)"
      ></app-button>
    </div>
  </form>
</ng-template>
